import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConnectionService, ToastsService } from '@catch/services';
import { Observable } from 'rxjs';
import { catchError, delay, filter, retry, timeout } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private toastService = inject(ToastsService);
  private connectionService = inject(ConnectionService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      retry({
        count: 4,
        delay: (error) => {
          if (error.status === 0) {
            if (!this.connectionService.connected && request.method !== 'GET') {
              this.toastService.warning('company-tool.other.problem-retry');
            }
            return this.connectionService.connected$.pipe(
              filter((online: boolean) => online),
              delay(20),
              timeout({
                each: 10000,
                with: () => {
                  throw error;
                }, //throw original error, not timeout error
              })
            );
          }
          throw error;
        },
      }),
      catchError((error) => {
        if (error.error?.message === 'Payment/ProviderError') {
          this.toastService.handleError('Payment/ProviderError');
          throw error;
        }
        if (!this.connectionService.connected) {
          this.toastService.handleError(
            'company-tool.other.no-connection-error'
          );
        } else if (request.method !== 'GET') {
          // For non-GET requests, show all errors
          if (
            error.status === 401 &&
            error.error?.message === 'Auth/Login/WrongCredentials'
          ) {
            this.toastService.handleError(error.error?.message ?? undefined);
          } else if (error.status === 500 && !error.error?.error) {
            this.toastService.handleError('General/UnknownError');
          } else if (error.status === 403 && !error.error?.error) {
            this.toastService.handleError('General/Forbidden');
          } else if (
            request.responseType !== 'blob' &&
            error.status !== 404 &&
            error.status !== 401 &&
            error.status !== 504 &&
            error.error?.message !== 'General/InvalidURL' &&
            error.status !== 0
          ) {
            this.toastService.handleError(error.error?.message ?? undefined);
          }
        }
        throw error;
      })
    );
  }
}
